import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FormInputProps } from './InputInterface';
import styled from 'styled-components';

const DabaduCheckbox = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    position: relative;
    margin-left: 0;
    margin-right: 0;
    + .MuiFormHelperText-root {
      margin-top: 0;
      margin-bottom: 5px;
      font-family: ${(props) => props.theme.fonts.primary};
    }
    &.align-top {
      display: flex;
      align-items: flex-start;
      .MuiCheckbox-root {
        padding-top: 0;
      }
    }
  }
  & .MuiCheckbox-root {
    color: ${(props) => props.theme.colors.checkboxColor};
    &.Mui-checked {
      color: ${(props) => props.theme.colors.checkboxColor};
    }
  }
  & .MuiTypography-root {
    font-family: ${(props) => props.theme.fonts.primary};
    font-size: 12px;
    font-weight: 300;
    line-height: 1.4;
  }
  & .MuiFormControl-root {
    color: red;
  }
`;

export const CheckboxInput = ({ name, control, label, rules, triggerValidationForField, className }: FormInputProps & { className?: string }) => {
  return (
    <FormControl required={Boolean(rules)} error={Boolean(rules)}>
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        rules={rules}
        render={({ field, formState: { errors } }) => (
          <>
            <DabaduCheckbox
              className={className}
              control={
                <Checkbox
                  {...field}
                  onChange={(val) => {
                    field.onChange(val.target.checked);
                    triggerValidationForField(name);
                  }}
                  checked={field.value}
                />
              }
              label={label}
            />
            {errors?.[name] && <FormHelperText>{errors?.[name]?.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};
